<p>splash works!</p>

<a routerLink="/map" href="#">CVV Map</a>